export default __webpack_public_path__ + "static/media/h7.e4657d9a.jpg";